<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                <v-icon class="me-2">mdi-filter</v-icon>
                Transfer History Report Filter
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">

                    <v-col lg="3" md="3" cols="12">
                      <v-date-input
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar-start"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        hide-details="auto"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-date-input
                        label="To Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar-end"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        hide-details="auto"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12" class="d-flex align-end">
                      <v-btn
                        type="submit"
                        color="primary"
                        :loading="loading"
                        prepend-icon="mdi-magnify"
                        density="compact"
                        height="40"
                        variant="flat"
                        ref="searchButton"
                      >
                        Search
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                <v-icon class="me-2">mdi-transfer-right</v-icon>
                Transfer History Report
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                
                <!-- Summary Cards -->
                <v-row class="py-2" v-if="summary.total_records > 0">
                  <v-col cols="12">
                    <v-card class="pa-4 bg-blue-grey-lighten-5">
                      <v-row>
                        <v-col md="6" cols="12">
                          <div class="text-subtitle-2 text-grey-darken-1">Total Transfer Records</div>
                          <div class="text-h5 font-weight-bold text-primary">{{ summary.total_records }}</div>
                        </v-col>
                        <v-col md="6" cols="12">
                          <div class="text-subtitle-2 text-grey-darken-1">Total Assets Transferred</div>
                          <div class="text-h5 font-weight-bold text-success">{{ summary.total_assets }}</div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row class="py-2">
                  
                  <v-col md="3" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="6" cols="12">
                    <div class="d-flex justify-center">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          :disabled="reports.length === 0"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          :disabled="reports.length === 0"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          :disabled="reports.length === 0"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12" class="d-flex align-center justify-end">
                    <v-btn
                      v-if="reports.length > 0"
                      variant="outlined"
                      size="small"
                      @click="expandAll"
                      prepend-icon="mdi-arrow-expand-all"
                    >
                      {{ allExpanded ? 'Collapse All' : 'Expand All' }}
                    </v-btn>
                  </v-col>

                </v-row>

                <!-- Grouped by Transfer Master -->
                <v-expansion-panels v-model="expandedPanels" multiple class="mt-2">
                  <v-expansion-panel
                    v-for="(master, index) in reports"
                    :key="master.id"
                    class="mb-2"
                  >
                    <v-expansion-panel-title class="bg-blue-grey-lighten-5">
                      <v-row no-gutters align="center">
                        <v-col cols="12" md="2">
                          <div class="text-caption text-grey-darken-1">Transfer Date</div>
                          <div class="font-weight-bold">{{ master.transfer_date }}</div>
                        </v-col>
                        <v-col cols="12" md="2">
                          <div class="text-caption text-grey-darken-1">From Location</div>
                          <v-chip size="small" color="warning" variant="outlined">
                            {{ master.from_location || 'N/A' }}
                          </v-chip>
                        </v-col>
                        <v-col cols="12" md="2">
                          <div class="text-caption text-grey-darken-1">To Location</div>
                          <v-chip size="small" color="success" variant="outlined">
                            {{ master.to_location || 'N/A' }}
                          </v-chip>
                        </v-col>
                        <v-col cols="12" md="2">
                          <div class="text-caption text-grey-darken-1">Transferred By</div>
                          <div class="font-weight-medium text-caption">{{ master.transferred_by || 'N/A' }}</div>
                        </v-col>
                        <v-col cols="12" md="2">
                          <div class="text-caption text-grey-darken-1">Assets Count</div>
                          <div class="font-weight-medium">
                            <v-chip size="small" color="primary">{{ master.details.length }}</v-chip>
                          </div>
                        </v-col>
                        <v-col cols="12" md="2" class="text-right">
                          <v-chip size="small" color="success" variant="outlined">
                            <v-icon start size="small">mdi-file-document-outline</v-icon>
                            View Details
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                      <!-- Header Info -->
                      <v-row class="mb-2">
                        <v-col cols="12" md="6" v-if="master.approved_by">
                          <v-alert type="success" variant="tonal" density="compact">
                            <strong>Approved By:</strong> {{ master.approved_by }}
                          </v-alert>
                        </v-col>
                        <v-col cols="12" :md="master.approved_by ? '6' : '12'" v-if="master.remarks">
                          <v-alert type="info" variant="tonal" density="compact">
                            <strong>Remarks:</strong> {{ master.remarks }}
                          </v-alert>
                        </v-col>
                      </v-row>

                      <v-data-table
                        :headers="detailHeaders"
                        :items="master.details"
                        :search="search"
                        :hover="true"
                        density="compact"
                        hide-default-footer
                        :items-per-page="-1"
                        class="elevation-1"
                      >
                        <template v-slot:item.index="{ index }">
                          {{ ++index }}
                        </template>

                        <template v-slot:item.condition="{ item }">
                          <v-chip 
                            size="small" 
                            :color="getConditionColor(item.condition)"
                          >
                            {{ item.condition || 'N/A' }}
                          </v-chip>
                        </template>

                        <template v-slot:item.remarks="{ item }">
                          <span class="text-caption">{{ item.remarks || '-' }}</span>
                        </template>

                      </v-data-table>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>

                <!-- No Data Message -->
                <v-row v-if="!loading && reports.length === 0" class="mt-4">
                  <v-col cols="12" class="text-center">
                    <v-icon size="64" color="grey">mdi-transfer-right</v-icon>
                    <p class="text-h6 text-grey mt-2">No transfer records found</p>
                    <p class="text-caption text-grey">Try adjusting the date filters</p>
                  </v-col>
                </v-row>

              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import Axios from "axios";
import { prefix } from "@/store/api";

export default {
  components: {},
  data() {
    return {
      itemsPerPage: 10,
      panel: [0],
      expandedPanels: [],
      allExpanded: false,
      search: "",
      detailHeaders: [
        { title: "#SL", align: "center", key: "index", sortable: false, width: "60px"},
        { title: "Asset Name", key: "asset_name", align: "center", sortable: false },
        { title: "Condition", key: "condition", align: "center", sortable: false },
        { title: "Remarks", key: "remarks", align: "center", sortable: false },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        from_date: yup.date().nullable().label('From Date'),
        to_date: yup.date().nullable().label('To Date'),
      }),
    });

    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref(false);
    const store = useStore();
    const reports = ref([]);
    const summary = ref({
      total_records: 0,
      total_assets: 0,
    });

    const submit = handleSubmit((values) => {
      loading.value = true;

      // Format dates if they exist
      const params = {
        from_date: from_date.value.value ? new Date(from_date.value.value).toISOString().split('T')[0] : null,
        to_date: to_date.value.value ? new Date(to_date.value.value).toISOString().split('T')[0] : null,
      };

      Axios.get(`${prefix}assets/reports/transfer-history`, { params })
        .then((response) => {
          if (response.data.status) {
            reports.value = response.data.data || [];
            
            // Update summary
            if (response.data.summary) {
              summary.value = response.data.summary;
            }
            
            toast.success('Data loaded successfully');
          } else {
            toast.error(response.data.message || 'Failed to load data');
            reports.value = [];
          }
          loading.value = false;
        })
        .catch((error) => {
          loading.value = false;
          reports.value = [];
          console.error('Transfer history error:', error);
          const errorMsg = error.response?.data?.message || error.message || 'An error occurred while loading data';
          toast.error(errorMsg);
        });
    });

    const formatCurrency = (val) => Number(val || 0).toLocaleString('en-BD', { minimumFractionDigits: 2 });

    return {
      from_date,
      to_date,
      submit,
      errorMessages,
      loading,
      reports,
      summary,
      formatCurrency,
    };
  },
  methods: {
    getConditionColor(condition) {
      const conditionMap = {
        'Good': 'success',
        'Fair': 'warning',
        'Poor': 'error',
        'Excellent': 'primary',
      };
      return conditionMap[condition] || 'grey';
    },
    expandAll() {
      if (this.allExpanded) {
        this.expandedPanels = [];
      } else {
        this.expandedPanels = this.reports.map((_, index) => index);
      }
      this.allExpanded = !this.allExpanded;
    },
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },

    exportToPDF() {
      let serialNumber = 1;
      const columns = [
        "#SL",
        "Transfer Date",
        "Code",
        "Asset Name",
        "From Location",
        "To Location",
        "Condition",
        "Remarks",
      ];
      const rows = [];
      
      (this.reports || []).forEach((master) => {
        master.details.forEach((detail) => {
          rows.push([
            serialNumber++,
            master.transfer_date,
            master.code || 'N/A',
            detail.asset_name,
            master.from_location || 'N/A',
            master.to_location || 'N/A',
            detail.condition || 'N/A',
            detail.remarks || '-',
          ]);
        });
      });

      this.$exportTableToPDF(
        columns,
        rows,
        "Transfer History Report",
        "transfer_history_report_" + this.$fileDate()
      );
    },
    exportToExcel() {
      var data = [[
        "#SL",
        "Transfer Date",
        "Code",
        "Asset Code",
        "Asset Name",
        "From Location",
        "To Location",
        "Condition",
        "Remarks",
      ]];
      var serialNumber = 1;
      
      (this.reports || []).forEach((master) => {
        master.details.forEach((detail) => {
          data.push([
            serialNumber++,
            master.transfer_date,
            master.code || 'N/A',
            detail.asset_name,
            master.from_location || 'N/A',
            master.to_location || 'N/A',
            detail.condition || 'N/A',
            detail.remarks || '-',
          ]);
        });
      });

      this.$exportTableToExcel(data, "transfer_history_report_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [[
        "#SL",
        "Transfer Date",
        "Code",
        "Asset Code",
        "Asset Name",
        "From Location",
        "To Location",
        "Condition",
        "Remarks",
      ]];
      var serialNumber = 1;
      
      (this.reports || []).forEach((master) => {
        master.details.forEach((detail) => {
          data.push([
            serialNumber++,
            master.transfer_date,
            master.code || 'N/A',
            detail.asset_name,
            master.from_location || 'N/A',
            master.to_location || 'N/A',
            detail.condition || 'N/A',
            detail.remarks || '-',
          ]);
        });
      });

      this.$exportTableToCSV(data, "transfer_history_report_" + this.$fileDate());
    },
  },
  mounted() {
    // Data will load only when user clicks Search button
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>

